module.exports = function getResource(label, vars = []) {
    let resources = {
        viewAll: 'Tout afficher'
    };

    return resources[label];
};
